import {all, call, put, select, takeEvery} from 'redux-saga/effects';
import {AdminOrganizationHttpClient, OrganizationChannelDto} from "admins-dashboard/http-clients/index";
import {ORPYXSI_ADMIN_URL} from "../../../../appConstants";
import {CHANNELS_INITIALIZE, CHANNELS_INITIALIZE_FAILED, CHANNELS_INITIALIZE_SUCCESSFULLY, ChannelsActions} from "./channels-actions";
import {ChannelsSelectors} from "./channels-selectors";

const API_VERSION = '1';

function* onGetChannels() {
    try {
        const api = new AdminOrganizationHttpClient(ORPYXSI_ADMIN_URL);
        const data: OrganizationChannelDto[] = yield call([api, api.getOrganizationChannels], API_VERSION);
        yield put(CHANNELS_INITIALIZE_SUCCESSFULLY(data));
    } catch (e) {
        yield put(CHANNELS_INITIALIZE_FAILED(e));
    }
}

//  Loads the dbo.OrganizationChannel lookup once, on first demand (organization create/update modal).
export function* ensureChannelsInitialized() {
    const initialized: boolean = yield select(ChannelsSelectors.initialized);
    if (!initialized) {
        yield put(CHANNELS_INITIALIZE());
    }
}

export default function* ChannelsSagas() {
    yield all([
        takeEvery(ChannelsActions.INITIALIZE, onGetChannels)
    ]);
}
